import React from "react";
import "../CSS/ProductSub.css";
import product1 from "../Assets/Cushion/1.jpg";
import product2 from "../Assets/Cushion/2.jpg";
import product3 from "../Assets/Cushion/3.jpg";
import product4 from "../Assets/Cushion/4.jpg";
import product5 from "../Assets/Cushion/5.jpg";

function Cushion() {
  window.scrollTo(0, 0);

  return (
    <div className="product-sub-main">
      <div className="product-sub-head">
        <h3>Cushion</h3>
      </div>
      <div className="product-sub-body">
        <div className="product-sub-flex">
          <img src={product1}></img>
          <img src={product2}></img>
          <img src={product3}></img>
        </div>
        <div className="product-sub-flex">
          <img src={product4}></img>
          <img src={product5}></img>
        </div>
      </div>
    </div>
  );
}
export default Cushion;
